<template>
    <div>
          <van-nav-bar
           title="订单核销"
           fixed
           :z-index="100"
         />
         <!-- 用户基本信息 -->
         <div class="orderlist">
                <div class="orderbody">
                  <section >
                    <span class="iconfont icon-dingwei"></span>
                    <ul>
                      <li>
                        {{ defAddressLists.province }}{{ defAddressLists.city
                        }}{{ defAddressLists.county }}
                      </li>
                      <li>{{ defAddressLists.address }}</li>
                        <li>
                        <span style='
                        font-size: .24rem;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #7E7E7E;
                        line-height: .3rem;
                        '>{{ defAddressLists.consignee }}</span
                        >&emsp;
                        <span style='
                        font-size: .24rem;
                        font-family: SF Pro Text;
                        font-weight: 500;
                        color: #7E7E7E;
                        line-height: .3rem;
                        '>{{ defAddressLists.phone }}</span>
                      </li>
                    </ul>
                    <span class="iconfont icon-qianjin" style='font-size:.24rem'></span>
                  </section>
                  <!-- 订单列表 -->
                  <div  class='card-center'>
                  <div class='shop-card' v-for="item in orderReqeust.skuList" :key="item.spuId">
                    <van-card
                      :num="item.num"
                      :desc="item.color"
                      :price="(item.price / 100.0).toFixed(2)"
                      :title="item.title"
                      :thumb="item.img"
                    ></van-card>
                    <van-field
                      v-model="item.remark"
                      label="订单备注"
                      type="textarea"
                      placeholder="未填写"
                      rows="1"
                      autosize
                      :maxlength="50"
                      disabled 
                    />
                  </div>
                  </div>
                </div>

                    <div class="payways">
                         <!-- 发票 -->
                         <!-- <van-cell title="发票" value="电子发票" is-link /> -->
                         <!-- 充值卡 -->
                         <!-- 优惠券单元格 -->
                         <div class='money-list'>
                         <van-cell
                           title="代金券"
                           :value="`${couponLists.length}张可用`"
                           v-if="couponLists.length && !couponMoney"
                         />
                         <van-cell
                           style="font-size: 0.28rem"
                           @click="goShowList()"
                           title="代金券"
                           :value="`优惠【${
                             couponMoney > remainMoney ? muchMoney / 100 : couponMoney / 100
                           }】元`"
                           v-else-if="couponLists.length && couponMoney"
                         />
                         <van-cell title="代金券" value="暂无可用" v-else></van-cell>

                         <van-cell class='cell-radero' title="运费" :value="defAddressLists.freightPrice" ></van-cell>
                         <van-cell class='cell-radero' title="商品金额" :value="` ￥${(defAddressLists.actualPrice/100).toFixed(2)}`" ></van-cell>

                         </div>
                    </div>
                <!-- 运费 -->
                <!-- <section class="transfee">
                  <p
                    class="purchase"
                    v-if="
                      orderInfo.internalScore != '0' && orderInfo.internalScore != undefined
                    "
                  >
                    <span style="font-size: 0.24rem; color: #cf4639">合计内购会积分：</span>
                    <span style="font-size: 0.24rem; color: #cf4639">{{
                      orderInfo.internalScore
                    }}</span>
                  </p>

                </section> -->
             

                 <div class="footerSumbit">
                    <Btn
                      @click.native="VerificationSheetBtn()"
                      v-preventReClick="5000"
                      class="clicked"
                      :disabled='isSave'
                      >立即核销</Btn
                    >
                </div>
        </div>
    </div>
</template>


<script>
import Btn from "../common/btn";
import { Dialog } from 'vant';
export default {
    components: {
      Btn,
    },
    data(){
        return{
            defAddressLists:{},
            orderReqeust:[],
            orderInfo:{},
            transFeeStringText:'',
            couponLists:[],
            isSave:false
        }
    },
    mounted(){
        this.getInit()
    },
    methods:{
        getInit(){
                  this.$api.order
                    .getOrderInfo({
                      orderId:  location.href.split('?order=')[1].split('&')[0],
                      userId: localStorage.getItem("userid"),
                    })
                    .then((res) => {
                        console.log(res);
                        this.defAddressLists = res.data
                        this.defAddressLists.freightPrice = '￥'+this.defAddressLists.freightPrice
                        this.orderReqeust = res.data
                    })
        },
        VerificationSheetBtn(){
            this.isSave = true
            this.$api.order
                .storeCheckOrder({
                    orderNo:location.href.split('?order=')[1].split('&')[1],
                    phone: localStorage.mobile
                }).then(res=>{
                  this.isSave = false
                  if(res.errno == '11002'){
                    this.$toast(res.errmsg)
                    Dialog.confirm({
                      title: res.errmsg,
                      message: '无操作权限,是否返回登录?',
                    })
                      .then(() => {
                        // on confirm
                        this.toLogin()
                      })
                      .catch(() => {
                        // on cancel
                      });
                    return
                  }
                  if(res.errno != '200'){
                      this.$toast(res.errmsg)
                  }
                  if(res.errno == 200){
                      this.$toast('核销成功')
                      this.$router.replace('/VerificationSheetSucceed')
                      this.isSave = true
                      return
                  }

                })
        },
        toLogin(){
          this.$router.replace({
            path: '/login',
            query: {
              redirect: this.$router.currentRoute.fullPath
            }
          })
        }

    }
}
</script>


<style lang='less' scoped>
@import "../../less/element.less";
@red: #cf4639;
.orderlist {
  width: 100%;
  box-sizing: border-box;
  padding: 0.76rem 0 1.28rem;
  .van-nav-bar {
    letter-spacing: 1px;
    background-color: #fafafa;
    .van-icon {
      color: #ccc;
    }
    .van-nav-bar__title {
      // color: @red;
    }
  }
  .orderbody {
    padding: 0.32rem 0.32rem 0.015rem;
    & > section {
      padding: 0.32rem;
      background: #fff;
      margin-bottom: 0.2rem;
      border-radius: 0.15rem;

      box-shadow: 0px 0px .15rem 0px rgba(0, 0, 0, 0.05);
      border-radius: .2rem;
      .list(row);
      justify-content: space-between;
      align-items: center;
      ul {
        li {
          font-size: 0.25rem;
          line-height: 0.48rem;
          &:first-child {
            span {
              &:first-child {
                color: black;
              }
              &:last-child {
                color: rgb(156, 155, 155);
              }
            }
          }
          &:last-child {
            color: @ordinary_icon_color;
            font-size: 0.25rem;
          }
        }
      }
      & > span {
        font-size: 0.48rem;
        &:first-child {
          font-size: 0.64rem;
          color: @dingwei_icon_color;
        }
        &:last-child {
          color: #ccc;
        }
      }
    }
    .van-card {
      // border-radius: 0.5rem 0.5rem 0 0;
      background: #fff;
      padding: 0.32rem 0.32rem 0;
      margin: 0;
      &:last-child {
        padding-bottom: 0.32rem;
      }
      .van-card__content {
        .van-card__title {
          line-height: 0.56rem;
          font-size: .26rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: .36rem;
          max-height: .8rem;
        }
        .van-card__price {
          color: @price_text_color;
        }
      }
    }
  }
  & > .transfee {
    padding: 0 0.32rem;
    p {
      text-align: right;
      background: #fff;
      font-size: 0.25rem;
      padding: 0.32rem;
      border-radius: 0 0 0.16rem 0.16rem;
    }
    .purchase {
      padding-bottom: 0;
      border-radius: 0;
    }
  }
  & > .payways {
    width: 100%;
    box-sizing: border-box;
    margin: 0.2rem 0 0;
    padding: 0 0.32rem;
    /deep/ .van-cell {
      border-radius: 0.16rem;
    }
    // 优惠券弹窗
    .van-popup {
      background-color: #f5f5f5;
      width: 100%;
      box-sizing: border-box;
      padding: 0.24rem 0.24rem 0.96rem;
      h1 {
        text-align: center;
        color: black;
        margin: 0.16rem 0 0.32rem;
      }
      .coupon-item {
        padding: 0.3rem .32rem .28rem .54rem;
        border-radius: 0.16rem;
        box-sizing: border-box;
        margin: 0 0 0.24rem;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
        background-color: #fff;
        font-size: 0.24rem;
        color: #bebebe;
        display: flex;
        justify-content: space-between;
        align-items: center;
         background: url('../../assets/images/coupon-list.png');
          background-size: cover;
          background-repeat:no-repeat;

          font-size: .22rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: #7E7E7E;
          line-height: .58rem;
        li {
          span {
            line-height: 0.38rem;
          }
        }
        .coupon-item-info {
          display: flex;
          align-items: center;
          flex: 1;

          .coupon-value{
            font-size: .5rem !important;
          }
          p {
            &:first-child {
              color: #d84b41;
              flex: 2;
              &.active {
                // color: #8c8c8c;
                font-size: .5rem;
                font-family: SF Pro Display;
                font-weight: bold;
                color: #FFFFFF;
                line-height: .58rem;
              }
            }
            &:last-child {
              flex: 4;
            }
          }
          .coupon-value {
            font-size: 0.38rem;
            font-weight: bold;
          }
          .coupon-name {
            // font-size: 0.32rem;
            // color: black;
            display: block;
            // margin-bottom: 0.18rem;
            font-size: .3rem;
            font-family: PingFang SC;
            font-weight: bold;
            color: #333333;
            line-height: .58rem;
            &.active {
            color: #333333;

              // color: #8c8c8c;
            }
          }
          .coupon-time {
            display: block;
          }
        }
      }
      .finised-btn {
        background-color: #fff;
        width: 100%;
        
        // box-sizing: border-box;
        padding:  0rem 0 0.16rem 0;
        left: 0;
        bottom: 0;
        z-index: 999;
        position: fixed;
        text-align: center;
        .btn {
          .btnmin(@bgcolor: @ordinary_btn_border_color, @color:#fff, @padding:0.5rem 0);
          width: 90%;
        }
      }
    }

    // 现金劵
    .van-collapse-item {
      margin: 0.06rem 0;
    }
    & /deep/ .van-collapse-item__content {
      padding: 0px 12px 6px;
    }
    & /deep/ .van-cell:not(:last-child)::after {
      border: none;
    }
    ul.self-pays {
      li {
        p {
          span {
            color: @ordinary_text_color;
            font-size: 0.21rem;
          }
        }
        &.other-pays {
          .list(row);
          justify-content: space-between;
        }
        & /deep/ .van-checkbox__label {
          color: #999;
          font-size: 0.24rem;
        }
        & /deep/ .van-field__body {
          border-bottom: 1px solid #f4f0f0;
        }
        & /deep/ .van-checkbox__icon--checked .van-icon {
          background-color: @radio_checked_color;
          border-color: @radio_checked_color;
        }
        & /deep/ .van-checkbox__icon {
          font-size: 0.28rem;
        }
      }
      .van-cell {
        padding: 10px 0;
      }
    }
  }
  .footerSumbit {
    padding: 0.16rem 0.32rem;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    z-index: 99;
    bottom: 0;
    background-color: #fff;
    .list(row);
    justify-content: space-between;
    align-items: center;
    color: @price_text_color;
    font-size: 0.25rem;
    height: ;
    p {
      flex: 1;
      .btn {
        width: 100%;
        .btnmin(@padding:0.24rem 0, @size:0.25rem, @radius:0.06rem, @color:#fff);
        background: @ordinary_btn_color;
        &.clicked {
          background: #ccc;
        }
      }
    }
  }
}
.radio-group-box {
  padding: 25px;
}
// .van-radio {
// }
.zfb {
  margin-top: 20px;
}
[v-cloak] {
  /*属性选择器*/
  display: none;
}
.invoice-box {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.24rem /* 40/50 */;
}
.invoice {
  height: 36px;
}
//价格大小
.van-card__price-integer {
  font-size: 0.32rem;
}
.van-card {
  font-size: 0.24rem;
}
.zfb-img {
  vertical-align: middle;
  width: 0.32rem;
  height: 0.32rem;
}
 // 弹窗
  .popupContent {
    box-sizing: border-box;
    width: 5.4rem /* 270/50 */;
    // height: 8rem;
    max-height: 8rem /* 400/50 */;
    border-radius: 0.2rem /* 10/50 */;
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: space-between;
    
    .popupContent-div{
      // margin-bottom: .68rem /* 34/50 */;
      padding: 0rem /* 23/50 */ 0.44rem /* 22/50 */ 0.4rem /* 20/50 */;
      overflow: scroll;
    }
    p {
      // text-indent: 2em;
      font-size: .28rem /* 14/50 */;
      font-family: PingFang SC;
      color: #333333;
    }
    .confirm {
      // margin-top: .4rem /* 20/50 */;
      width: 100%;
      font-size: 0.32rem /* 16/50 */;
      font-weight: 500;
      border-top: .02rem /* 1/50 */ solid #efefef;
      // position:fixed;
      left: 0;
      bottom: 0;
      // border: 0 .1rem /* 5/50 */ .1rem /* 5/50 */ 0;
      .confirm-btn{
        font-family: PingFang SC;
        height: .88rem /* 44/50 */;
        line-height:.88rem /* 44/50 */;
        width: 50%;
        border-left: none;
        border-top: none;
      }
      .btn{
        color: #bb1d1f;
        border-bottom-right-radius: .2rem;
        border-bottom: none;

      }
      .btns{
        color: #7e7e7e;
        border-bottom-left-radius: .2rem;
        border-bottom: none;

      }
    }
  }
    .title-h2 {
      padding-top: .4rem /* 20/50 */;
      padding-bottom: .24rem /* 12/50 */;
      text-align: center;
      font-size: .32rem /* 16/50 */;
      font-weight: 700;
    }
    .confirm-toUpdate{
      // margin-top: .4rem /* 20/50 */;
      width: 100%;
      font-size: 0.32rem /* 16/50 */;
      font-weight: 500;
      border-top: .02rem /* 1/50 */ solid #efefef;
      // position:fixed;
      left: 0;
      bottom: 0;
      .confirm-btn-toUpdate{
        font-family: PingFang SC;
        height: .88rem /* 44/50 */;
        line-height:.88rem /* 44/50 */;
        width: 50%;
        border-top: none;
        border-left: none;
        .btn{
          color: #bb1d1f;
        }
      }
    }
  .text-v{
    display: inline-block;
    margin-top: .05rem /* 20/50 */;
    line-height: 1.5;
  // text-indent: 2em;
  }
  .coupon-title{
    font-size: .28rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: .5rem;
  }
  .coupon-save{
    height: .9rem;
    background: linear-gradient(0deg, #EE3A3A, #F46161);
    border-radius: .1rem !important;
    font-size: .36rem !important;
    font-family: PingFang SC;
    font-weight: 500;
    padding: 0 !important;
    line-height: .9rem !important;
  }
  .van-card__desc{
    font-size: .26rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #AEAEAE;
    line-height: .36rem;
  }
  .money-list{
    background: #FFFFFF;
    box-shadow: 0px 0px .15rem 0px rgba(0, 0, 0, 0.05);
    border-radius: .2rem;
    overflow: hidden;
  }
  .cell-radero{
    border-radius: 0 !important;
  }
  .shop-card{
    // box-shadow: 0px 0px .15rem 0px rgba(0, 0, 0, 0.05);
    // border-radius: .2rem;
    overflow: hidden;
    // margin-bottom: .3rem;
  }
  /deep/ .van-field__control::-webkit-scrollbar{
    display: none;
  }
  .card-center{
    background: #fff;
    box-shadow: 0px 0px .15rem 0px rgba(0, 0, 0, 0.05);
    border-radius: .2rem;
    overflow: hidden;
    padding-bottom: .2rem;
  }

   .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 4.2rem;
    height:4.2rem;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: .2rem;
  }
  .van-overlay{
    z-index: 200;
  }
  .clicked{
      text-align: center;
      width: 92vw;
      color: #fff;
      line-height: .86rem;
      font-size: .36rem;
      height: .86rem;
      border-radius: .2rem;
      background: var(--theme)
  }
</style>
